export const ROLE_DELETE_RESET = 'ROLE_DELETE_RESET'
export const ROLE_DELETE_SET_ERROR = 'ROLE_DELETE_SET_ERROR'
export const ROLE_DELETE_SET_DELETED = 'ROLE_DELETE_SET_DELETED'
export const ROLE_DELETE_TOGGLE_LOADING = 'ROLE_DELETE_TOGGLE_LOADING'
